<template>
    <el-form
        ref="reform"
        :model="form"
        :label-width="labelWidth"
        :rules="rules"
        :disabled="disabled"
        v-bind="$attrs"
    >
        <el-row>
            <el-col
                v-for="(item, idx) of wrapperList"
                :key="item.label + item.prop + idx"
                v-bind="item.position"
            >
                <el-form-item v-bind="getFormItemAttrs(item)">
                    <slot :name="item.prop" v-bind="item">
                        <component
                            :is="item.render"
                            v-model.trim="form[item.prop]"
                            v-bind="item.attrs"
                            v-on="item.listeners"
                        >
                        <el-button slot="append" v-if="item.attrs.btn" icon="el-icon-search" v-on="item.listeners"></el-button>
                        </component>
                    </slot>
                </el-form-item>
            </el-col>

            <el-col class="submits">
                <slot v-if="$slots.after || btns.length" name="after">
                    <template v-for="(btn, idx) of wrapperBtns">
                        <el-button
                            :key="btn.label + idx"
                            v-bind="btn.attrs"
                            :loading="loading"
                            v-on="btn.listeners"
                            >{{ btn.label }}</el-button
                        >
                    </template>
                </slot>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
const DEFAULT_CONFIG = {
    render: "ElInput",
    get attrs() {
        return {};
    },

    get position() {
        return {
            span: 8,
        };
    },

    get listeners() {
        return {};
    },
};

export default {
    name: "Form",
    model: { prop: "form" },
    inheritAttrs: false,
    props: {
        form: {
            type: Object,
            default: () => ({}),
            comment: "v-model",
        },
        loading:{
            type:Boolean,
            default:false
        },
        list: {
            type: Array,
            default: () => [],
            comment: "form list",
        },
        btns: {
            type: Array,
            default: () => [],
            comment: "operator buttons",
        },
        rules: {
            type: Object,
            default: () => ({}),
            comment: "form rules",
        },
        disabled: {
            type: Boolean,
            default: false,
            comment: "disabled form",
        },
        labelWidth: {
            type: [String, Number],
            default: "100px",
        },
    },
    data() {
        return {};
    },

    computed: {
        wrapperList({ list }) {
            return list.reduce((item, field) => {
                if (field.prop)
                    item.push(Object.assign({}, DEFAULT_CONFIG, field));
                return item;
            }, []);
        },
        wrapperBtns({ btns }) {
            return btns.map((btn) =>
                Object.assign({}, DEFAULT_CONFIG.listeners, btn)
            );
        },
    },

    async mounted() {
        await this.$nextTick();
        this.exposeFormMethods();
    },

    methods: {
        exposeFormMethods() {
            const methods = [
                "validate",
                "resetFields",
                "validateField",
                "clearValidate",
            ];

            const reform = this.$refs.reform;

            methods.forEach((method) => {
                this[method] = (...rest) => reform[method].apply(this, rest);
            });
        },

        getFormItemAttrs({ attrs, position, listeners, render, ...props }) {
            return { ...props };
        },
    },
};
</script>